import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ILink, NcgLocationMapCategory, NgcApiLocation } from '@ncg/data';
import { ScrollService } from '../../../core/scroll.service';

import { ICoordinations } from '../map-container.component';

@Component({
    selector: 'ncg-map-list',
    template: `
        <div class="map-list" *ngIf="locations">
            <div class="map-list__header level">
                <p class="map-list__header--result" *ngIf="locations?.length">
                    {{ locations?.length }} {{ 'map.locations_amount_suffix' | translate }}
                </p>
            </div>
            <div class="map-list__space"></div>
            <div class="map-list__items" #mapListItems>
                <div
                    (click)="onMapItemClicked(location, i)"
                    class="map-item"
                    [ngClass]="{ 'map-item--is-active': currentItem && location.store_code === currentItem.store_code }"
                    *ngFor="let location of locations; let i = index; trackBy: trackByLocation">
                    <ncg-map-location-info
                        [isBrandLayout]="isBrandLayout"
                        [currentCategory]="currentCategory"
                        [serviceLink]="serviceLink"
                        [testDriveLink]="testDriveLink"
                        [hideServiceButton]="hideServiceButton"
                        [hideTestDriveButton]="hideTestDriveButton"
                        [contactLink]="contactLink"
                        [hideContactButton]="hideContactButton"
                        [userCurrentPosition]="userCurrentPosition"
                        [location]="location"
                        [markerIconUrl]="markerIconUrl"
                        [openingHoursLink]="openingHoursLink"></ncg-map-location-info>
                </div>
            </div>
            <div class="map-list__space"></div>
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class MapListComponent implements AfterViewInit {
    @ViewChild('mapListItems')
    public mapListItemsRef: ElementRef;
    @Input()
    public locations?: NgcApiLocation[];
    @Input()
    public userCurrentPosition?: ICoordinations;
    @Output()
    public mapItemCliked: EventEmitter<any> = new EventEmitter();
    @Input()
    public currentItem?: NgcApiLocation;
    @Input()
    public serviceLink?: ILink;
    @Input()
    public testDriveLink?: ILink;
    @Input()
    public hideServiceButton?: boolean;
    @Input()
    public hideTestDriveButton?: boolean;
    @Input()
    public contactLink?: ILink;
    @Input()
    public hideContactButton?: boolean;
    @Input()
    public markerIconUrl: string;
    @Input()
    public currentCategory?: NcgLocationMapCategory;
    @Input()
    public isBrandLayout?: boolean;
    @Input()
    public openingHoursLink?: ILink;

    constructor(private readonly scrollService: ScrollService) {}

    public ngAfterViewInit(): void {
        setTimeout(() => {
            this.scrollToMapListItem();
        }, 0);
    }

    public onMapItemClicked(item: NgcApiLocation, index: number) {
        if (this.currentItem && this.currentItem.store_code === item.store_code) {
            return;
        }

        this.mapItemCliked.emit({ currentItem: item, index });
    }

    public trackByLocation(_index: number, item: NgcApiLocation) {
        return item.store_code;
    }

    private scrollToMapListItem() {
        const element = this.mapListItemsRef.nativeElement.querySelector('.map-item--is-active');
        this.scrollService.scrollToElement(element, { block: 'end' });
    }
}
